module.exports = __webpack_public_path__ + "img/statistics_outlined_24.033e7441.svg";